import {
  anAddInsightComment,
  anInsightHistoryEvent,
  anUpdateInsight,
  aUser,
  mockUpdateInsightOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const updateInsightAssignee = aUser();

export const updateInsightResponse = {
  __typename: 'Mutation' as const,
  addInsightComment: anAddInsightComment(),
  updateInsight: {
    ...anUpdateInsight(),
    data: {
      ...anUpdateInsight().data,
      history: [
        {
          ...anInsightHistoryEvent(),
          body: anInsightHistoryEvent().description,
        },
      ],
    },
  },
};

export const handlers = [
  mockUpdateInsightOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: updateInsightResponse,
      });
    }
  ),
];
